import { TransactionReport } from '../../../application/types/transactionReport.ts';
import { axiosInstance } from '../../../common/axiosInstans.ts';

class ReportService {
    async getTransactionReport(
        storageId: string,
        drugId: string,
        fromDate: string,
        toDate: string,
        secureKey?: string
    ): Promise<TransactionReport[]> {
        try {
            const params = new URLSearchParams({
                fromDate,
                toDate,
            });

            // Prepare headers
            const headers: Record<string, string> = {};
            if (secureKey) {
                headers['X-Secure-Key'] = secureKey;
            }

            const { data } = await axiosInstance.get(
                `/report/secured/${storageId}/${drugId}?${params.toString()}`,
                { headers }
            );
            return data;
        } catch (error) {
            console.error('Error fetching transaction log:', error);
            throw error;
        }
    }
}

export default ReportService;
